"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderObjArrByDate = orderObjArrByDate;
exports.getObjArrWeightedAvg = getObjArrWeightedAvg;
function orderObjArrByDate(objectArray, options) {
    var _a, _b;
    const selectedOrder = (_a = options === null || options === void 0 ? void 0 : options.order) !== null && _a !== void 0 ? _a : 'desc';
    const selectedKey = (_b = options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : 'date';
    return objectArray.sort(function (a, b) {
        if (selectedOrder === 'asc')
            return new Date(a[selectedKey]).valueOf() - new Date(b[selectedKey]).valueOf();
        return new Date(b[selectedKey]).valueOf() - new Date(a[selectedKey]).valueOf();
    });
}
function getObjArrWeightedAvg(objectArray, key) {
    const filter = p => a => a.filter(p);
    const map = f => a => a.map(f);
    const prop = k => x => x[k];
    const reduce = r => i => a => a.reduce(r, i);
    const compose = (...fns) => (arg) => fns.reduceRight((arg, fn) => fn(arg), arg);
    const lift = f => g => h => x => f(g(x))(h(x));
    const sum = reduce((a, i) => a + i)(0);
    const length = a => a.length;
    const div = a => b => a / b;
    const calculateWeightedAverage = compose(lift(div)(sum)(length), map(prop(key)), filter(prop('found')));
    return calculateWeightedAverage(objectArray);
}
//# sourceMappingURL=array.js.map